import { createElement } from "./globalFunctions";

/**
 * Move cart header to the top of the cart content
 */
const moveCartHeader = () => {
  const pageHeader = document.querySelector("#header");
  const content = document.querySelector("#content");
  const cartHeader = document.querySelector(".cart-content .cart-header");
  const cartHeaderHelper = document.querySelector(".cart-header-wrapper");
  if (cartHeader && !cartHeaderHelper) {
    const cartHeaderWrapper = createElement("div", ["cart-header-wrapper"]);
    cartHeaderWrapper.appendChild(cartHeader);
    cartHeader.classList.add("container");
    // content.prepend(cartHeaderWrapper)
    pageHeader.parentElement.insertBefore(
      cartHeaderWrapper,
      pageHeader.nextElementSibling
    );
  } else if (cartHeader && cartHeaderHelper) {
    cartHeader.remove();
  }
};

let summaryWrapper = document.querySelector(".summary-wrapper");
/**
 * Move extra delivery to the sidebar
 */
const moveExtraDeliveryToSidebar = () => {
  const sidebarInCart = document.querySelector(".sidebar-in-cart");

  const extraDelivery = document.querySelector(".extra.delivery");
  // if (!extraDelivery || !summaryWrapper) return
  if (!extraDelivery || !sidebarInCart) return;

  sidebarInCart.prepend(extraDelivery);
};

/**
 * Move coupon field to the sidebar
 */
const moveCouponFieldToSidebar = (withHeading = false) => {
  const couponField = document.querySelector(".discount-coupon");
  summaryWrapper = document.querySelector(".summary-wrapper > .box-bg-default");
  if (!couponField || !summaryWrapper) return;
  summaryWrapper.prepend(couponField);
  if (withHeading) {
    const couponFieldHeading = createElement(
      "h5",
      ["heading"],
      window.language === "cs" ? "Dárkový poukaz" : "Darčekový poukaz"
    );
    couponField.prepend(couponFieldHeading);
  }
};

/**
 * Create a cart footer and append it to the DOM
 * @returns {HTMLElement} cartFooter - The cart footer element that was created and appended to the DOM
 */
const createCartFooter = () => {
  const overallWrapper = document.querySelector(".overall-wrapper");
  if (!overallWrapper) return;
  if (document.querySelector(".cart-footer")) return;
  const cartFooter = createElement("div", ["cart-footer"]);
  const projectPhone = document.querySelector(".project-phone");
  const projectMail = document.querySelector(".project-email");

  cartFooter.innerHTML = `
				<div class="container">
					<div class="secure-payment">
						<span>${
              window.language === "cs" || window.language === "sk"
                ? "Bezpečná platba"
                : ""
            }</span>
						<img src="https://698129.myshoptet.com/user/documents/upload/icons/platebni_metody.png" width="180" height="20" alt="Visa, MasterCard, Maestro">
					</div>
					<div class="contact-box phone-wrapper add-icon">${
            projectPhone ? projectPhone.outerHTML : ""
          }${
    typeof textKCislu !== "undefined" ? `<span>${textKCislu}</span>` : ""
  }
					</div>
					<div class="contact-box mail-wrapper add-icon">${
            projectMail ? projectMail.outerHTML : ""
          }${
    typeof textKMailu !== "undefined" ? `<span>${textKMailu}</span>` : ""
  }
					</div>
				</div>
		`;

  overallWrapper.appendChild(cartFooter);
  return cartFooter;
};

/**
 * Create a cart popup summary - single price, total price, price without VAT, free shipping bar, and a button
 * @param {boolean} disableSinglePrice - Disable single price in the cart popup summary
 * @param {boolean} disablePriceWithoutVAT - Disable price without VAT in the cart popup summary
 */
const createCartPopupSummary = (
  disableSinglePrice = false,
  disablePriceWithoutVAT = false
) => {
  document.addEventListener("ShoptetDOMCartContentLoaded", () => {
    const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol;
    const cartWidgetProducts = document.querySelectorAll(
      ".cart-widget-product"
    );
    for (const product of cartWidgetProducts) {
      const productPrice = product.querySelector(
        'span[data-testid="cartWidgetProductPrice"]'
      );
      if (productPrice && !disableSinglePrice) {
        const priceEl = createElement("div", ["cart-widget-product-price"]);
        priceEl.appendChild(productPrice);
        product.appendChild(priceEl);
        const productSKU = product.getAttribute("data-micro-sku");
        if (productSKU) {
          const productSinglePrice = dataLayer[0].shoptet.cart.filter(
            (item) => item.code === productSKU
          )[0].priceWithVat;
          const productSinglePriceEl = createElement("div", [
            "cart-widget-product-single-price",
          ]);
          productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks`;
          priceEl.appendChild(productSinglePriceEl);
        }
      }
    }
    let popupCartSummary = document.querySelector(".popup-cart-summary");
    if (!popupCartSummary)
      popupCartSummary = createElement("div", ["popup-cart-summary"]);
    const popupCartSummaryPriveVAT =
      dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat;
    const popupCartSummaryPriceNoVAT =
      dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat;
    popupCartSummary.innerHTML = `
            <div class="popup-cart-summary-item">
                <strong class="popup-cart-summary-item-label">Celkem</strong>
                <strong class="popup-cart-summary-item-value">${popupCartSummaryPriveVAT} ${currencyLabel}</strong>
            </div>
            ${
              !disablePriceWithoutVAT
                ? `
                        <div class="popup-cart-summary-item">
                            <span class="popup-cart-summary-item-label">Celkem bez DPH</span>
                            <span class="popup-cart-summary-item-value">${Math.round(
                              popupCartSummaryPriceNoVAT
                            )} ${currencyLabel}</span>
                        </div>`
                : ""
            }
		`;
    const cartWidgetProductsWrapper = document.querySelector(
      ".cart-widget-products"
    );
    if (cartWidgetProductsWrapper)
      cartWidgetProductsWrapper.parentElement.insertBefore(
        popupCartSummary,
        cartWidgetProductsWrapper.nextElementSibling
      );

    const cartWidgetButton = document.querySelector(".cart-widget-button");
    const cartWidgetInner = document.querySelector(".cart-widget-inner");
    if (cartWidgetButton && cartWidgetInner)
      cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true));

    const cartWidgetShipping = document.querySelector(".cart-free-shipping");
    if (cartWidgetShipping) {
      const priceLeftToFreeShipping =
        dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft;
      if (priceLeftToFreeShipping > 0) {
        const freeShippingBar = createElement("div", ["price-range"]);
        const freeShippingValue = createElement("div");
        freeShippingBar.appendChild(freeShippingValue);
        freeShippingValue.style.width = `${
          100 -
          (100 * priceLeftToFreeShipping) /
            (priceLeftToFreeShipping + popupCartSummaryPriveVAT)
        }%`;
        cartWidgetShipping.appendChild(freeShippingBar);
      }
    }
  });
};
const changePlaceholderDiscountCoupon = () => {
  const discountCouponInput = document.querySelector("#discountCouponCode");
  if (!discountCouponInput) return;
  discountCouponInput.placeholder = "Kód poukazu";
};
const makePriceTotalSeparateTd = () => {
  if (window.innerWidth > 768) {
    const removeables = document.querySelectorAll(".cart-table tr.removeable");
    for (const removeable of removeables) {
      const priceTotal = removeable.querySelector(".p-total .price-final");
      if (!priceTotal) return;
      const pTotalSeparate = createElement("td", ["p-total-separate"]);
      pTotalSeparate.appendChild(priceTotal);
      const pPrice = removeable.querySelector(".p-price");
      if (pPrice) pPrice.before(pTotalSeparate);
      const pImage = removeable.querySelector(".cart-p-image img");

      if (!pImage) return;
      pImage.dataset.src = pImage.dataset.src.replace("related", "big");
      const removeItem = removeable.querySelector(".remove-item");
      if (removeItem) {
        removeItem.textContent = "Odebrat";
      }
    }
  }
};

const freeShippingOnExtraDelivery = () => {
  const extraDelivery = document.querySelector(".extra.delivery span");
  if (extraDelivery) {
    if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0)
      extraDelivery.classList.add("for-free");
  }
};

const changeBtnToHeadingCheckoutBox = () => {
  const btn = document.querySelector(
    ".btn.btn-block.btn-default.toggle-contacts"
  );
  if (btn) {
    const heading = createElement(
      "h4",
      ["heading"],
      btn.innerText.split("\n")[0]
    );
    btn.replaceWith(heading);
  }
};

const handleStepBack = (text) => {
  const cartInner = document.querySelector(".cart-inner .col-md-8");
  const cartContent = document.querySelector(".cart-inner .col-md-4");
  const stepBack = document.querySelector(".next-step .next-step-back");
  const backShopping = document.querySelector(".back-shopping-link");
  if (!cartInner) return;
  if (backShopping) {
    cartInner.appendChild(backShopping);
    if (text) stepBack.innerText = text;
  }
  if (stepBack) {
    if (text) stepBack.innerText = text;
    stepBack.classList.add("btn-tertiary");
    if (window.innerWidth > 767) {
      if (backShopping) {
        backShopping.prepend(stepBack);
      } else {
        cartInner.appendChild(stepBack);
      }
    } else {
      if (backShopping) {
        backShopping.prepend(stepBack);
      } else {
        cartContent.appendChild(stepBack);
      }
    }
  }
};
const buttonToBilling = (buttonText) => {
  const checkoutContent = document.querySelector("#checkoutContent");
  if (!checkoutContent) return;
  const backButton = document.querySelector(".next-step-back");
  if (!backButton) return;
  const backButtonHref = backButton.getAttribute("href");
  const buttonToBilling = createElement("a", [
    "btn",
    "btn-lg",
    "back-step",
    "btn-tertiary",
  ]);
  buttonToBilling.setAttribute("href", backButtonHref ? backButtonHref : "#");
  buttonToBilling.textContent = buttonText;
  checkoutContent.prepend(buttonToBilling);
};
const changeTextInOrderBtn = (text) => {
  const orderBtn = document.querySelector(
    ".next-step:not(.next-step--step-2) .order-button-text"
  );
  if (orderBtn) orderBtn.innerText = text;
};

const createCartHeading = (text) => {
  const cartTable = document.querySelector(".cart-content .cart-table");
  if (!cartTable || document.querySelector(".cart-table-heading")) return;
  const cartHeading = createElement(
    "h2",
    ["cart-table-heading"],
    text ? text : ""
  );
  cartTable.before(cartHeading);
};

const changeNameForPaymentType = (text) => {
  setTimeout(() => {
    const paymentTypeName =
      document.querySelector(
        ".cart-items .recapitulation-single:nth-child(2) > span"
      ) || document.querySelector(".recapitulation-single.last > span");

    if (paymentTypeName && text) {
      paymentTypeName.innerText = text;
    }
  });
};
const shippingToSidebar = () => {
  const shipping = document.querySelector(".extra.delivery");
  const summaryWrapper = document.querySelector(".summary-wrapper");
  if (!shipping || !summaryWrapper) return;
  summaryWrapper.appendChild(shipping);
};
const visibleNoteForSeller = () => {
  var addNote = document.getElementById("add-note");
  if (addNote) {
    addNote.setAttribute("checked", "true");
  }

  var note = document.getElementById("note");
  if (note) {
    note.classList.add("visible");
  }
};

export {
  changePlaceholderDiscountCoupon,
  moveCartHeader,
  moveExtraDeliveryToSidebar,
  moveCouponFieldToSidebar,
  createCartFooter,
  createCartPopupSummary,
  makePriceTotalSeparateTd,
  freeShippingOnExtraDelivery,
  changeBtnToHeadingCheckoutBox,
  handleStepBack,
  changeTextInOrderBtn,
  createCartHeading,
  changeNameForPaymentType,
  shippingToSidebar,
  buttonToBilling,
  visibleNoteForSeller,
};
